import React from "react";
import { useNavigate } from "react-router-dom";

export default function LoginPopup({ show, redirectPath = "/appointments", onClose }) {
  const navigate = useNavigate();

  if (!show) return null;

  const handleBackToHome = () => {
    if (onClose) {
      onClose(); // Home page: just close the popup
      return;
    }
    navigate("/"); // Other pages: navigate to home
  };

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
      background: "rgba(0,0,0,0.5)", zIndex: 9999,
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        background: "#fff", borderRadius: "12px", padding: "40px 32px",
        maxWidth: "400px", width: "90%", textAlign: "center",
        boxShadow: "0 10px 40px rgba(0,0,0,0.2)"
      }}>

        <div style={{
          width: "60px", height: "60px", borderRadius: "50%",
          background: "#eaf4fb", display: "flex", alignItems: "center",
          justifyContent: "center", margin: "0 auto 16px"
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
                d="M17 9h-1V7a4 4 0 10-8 0v2H7a2 2 0 00-2 2v8a2 2 0 002 2h10a2 2 0 002-2v-8a2 2 0 00-2-2zm-6 7a2 2 0 114 0 2 2 0 01-4 0zm3-7H10V7a2 2 0 114 0v2z"
                fill="#3c8dbc"
            />
            </svg>
        </div>

        <h3 style={{ marginBottom: "8px", color: "#2c3e50", fontSize: "20px", fontWeight: "700" }}>
          Sign In Required
        </h3>
        <p style={{ color: "#6b7a8d", marginBottom: "28px", fontSize: "14px", lineHeight: "1.5" }}>
          Please sign in to book an appointment.
        </p>

        <button
          onClick={() => {
            localStorage.setItem("redirectAfterLogin", redirectPath);
            navigate("/signIn");
          }}
          style={{
            width: "100%", padding: "12px", marginBottom: "10px",
            background: "linear-gradient(135deg,#3c8dbc 0%,#2575a8 100%)",
            color: "#fff", border: "none", borderRadius: "6px",
            fontSize: "15px", fontWeight: "700", cursor: "pointer",
            boxShadow: "0 2px 8px rgba(60,141,188,0.3)"
          }}
        >
          Sign In to Continue
        </button>

        <button
          onClick={handleBackToHome}
          style={{
            width: "100%", padding: "10px",
            background: "none", border: "1.5px solid #dce3ea",
            borderRadius: "6px", color: "#6b7a8d",
            fontSize: "14px", fontWeight: "600", cursor: "pointer"
          }}
        >
          Back to Home
        </button>

      </div>
    </div>
  );
}